import * as type from '../types';

const initialState = {
  redemptionData: {},
};

export default function portal(state = initialState, action) {
  switch (action.type) {
    case type.SET_PORTAL_DATA:
      return {
        ...state,
        redemptionData: action.payload,
      };
    default:
      return state;
  }
}
